/* ==========================================
   NICOLAS CARE 6TH ANNIVERSARY DRAW
   Spend $100+ on eligible products to qualify
   ========================================== */

(function () {
  const THRESHOLD = 10000; // $100 in cents

  let previousTotal = null;

  function getMoneyFormatter(currency) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  }

  async function updateNicolasAnniversaryDraw() {
    const box = document.querySelector('#nc-anniversary-draw');

    if (!box) return;

    try {
      /*
       * Eligible subtotal is calculated in Liquid
       * using only products tagged "iphone18".
       */
      const total = Number(
        box.dataset.eligibleTotal || 0
      );

      /*
       * We still fetch the cart only to get
       * the active cart currency.
       */
      const root =
        window.Shopify && Shopify.routes
          ? Shopify.routes.root
          : '/';

      const response = await fetch(root + 'cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });

      let currency = 'USD';

      if (response.ok) {
        const cart = await response.json();
        currency = cart.currency || 'USD';
      }

      const title =
        box.querySelector('#nc-draw-title');

      const message =
        box.querySelector('#nc-draw-message');

      const progress =
        box.querySelector('#nc-draw-progress');

      const remaining =
        box.querySelector('#nc-draw-remaining');

      if (!title || !message || !progress || !remaining) return;

      const percent = Math.min(
        (total / THRESHOLD) * 100,
        100
      );

      progress.style.width = percent + '%';

      const qualifies = total >= THRESHOLD;

      if (!qualifies) {
        const amountLeft = THRESHOLD - total;

        const formattedAmount =
          getMoneyFormatter(currency).format(
            amountLeft / 100
          );

        box.classList.remove('nc-draw--qualified');

        title.textContent =
          '📱 WIN AN iPHONE 18 PRO';

        message.innerHTML =
          'You’re <strong>' +
          formattedAmount +
          '</strong> away from qualifying for our Anniversary Draw!';

        remaining.innerHTML =
          'Spend $100+ on eligible products for your chance to win 🎉';
      } else {
        box.classList.add('nc-draw--qualified');

        title.innerHTML =
          '🎉 CONGRATULATIONS — YOU QUALIFY!';

        message.innerHTML =
          'Complete your purchase to enter our Anniversary Draw for a chance to <strong>WIN an iPhone 18 PRO! 📱</strong>';

        remaining.innerHTML =
          'Anniversary Draw qualification unlocked ✓';

        /*
         * Celebrate only when the eligible subtotal
         * crosses the $100 threshold.
         */
        if (
          previousTotal !== null &&
          previousTotal < THRESHOLD &&
          total >= THRESHOLD
        ) {
          launchNicolasConfetti();
        }
      }

      previousTotal = total;
    } catch (error) {
      console.error(
        'Nicolas Care Anniversary Draw:',
        error
      );
    }
  }


  function launchNicolasConfetti() {
    const colors = [
      '#d8b19a',
      '#c79a79',
      '#f4d8ca',
      '#8f624c',
      '#f7eee8',
      '#ffffff'
    ];

    for (let i = 0; i < 55; i++) {
      const piece = document.createElement('span');

      piece.className = 'nc-confetti';

      piece.style.left =
        Math.random() * 100 + 'vw';

      piece.style.backgroundColor =
        colors[Math.floor(Math.random() * colors.length)];

      piece.style.transform =
        'rotate(' + Math.random() * 360 + 'deg)';

      piece.style.transition =
        'top ' +
        (1.8 + Math.random()) +
        's ease-out, transform 2.5s linear, opacity 2.5s ease';

      document.body.appendChild(piece);

      requestAnimationFrame(function () {
        piece.style.top =
          75 + Math.random() * 25 + 'vh';

        piece.style.transform =
          'rotate(' +
          (720 + Math.random() * 720) +
          'deg)';

        piece.style.opacity = '0';
      });

      setTimeout(function () {
        piece.remove();
      }, 3000);
    }
  }


  /*
   * Make the function available to Symmetry.
   */
  window.updateNicolasAnniversaryDraw =
    updateNicolasAnniversaryDraw;


  /*
   * Initial cart state.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateNicolasAnniversaryDraw
    );
  } else {
    updateNicolasAnniversaryDraw();
  }
})();